import PropTypes from 'prop-types';

export const propTypes = {
  shouldShowCloseButton: PropTypes.bool,
};
